import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa6';
import { Modal } from 'bootstrap';

import { useDispatch, useSelector } from 'react-redux';
import { getAuthenticatedUser } from '../../../../actions/auth';
import { changeTransactionPin, resetTransactionPin, resetTransactionPinRequest, setTransactionPin } from '../../../../api/user';
import { getUserDetails, refreshUserDetails } from '../../../../actions/user';
import { PiEyeSlashThin, PiEyeThin } from 'react-icons/pi';

const ChangePin = () => {
    const userDetails = useSelector((state) => state.user.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const hasPinSet = userDetails?.has_set_pin || false;
    const [oldPin, setOldPin] = useState("");
    const [newPin, setNewPin] = useState("");
    const [confirmPin, setConfirmPin] = useState("");
    const [isEdited, setIsEdited] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const currentPage = window.location.pathname;
    const isSettingPage = currentPage.includes("user/settings");
    const [isPinReset, setIsPinReset] = useState(false);
    const [otp, setOtp] = useState("");
    const [passwordType, setPasswordType] = useState("password");
    // console.log(hasPinSet);
    

    const togglePasswordVisibility = (setter, currentType) => {
        setter(currentType === 'password' ? 'text' : 'password');
    };
    

    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
        setIsEdited(true);
    };

    const handlePinSetting = async (e) => {
        e.preventDefault();
        if (!newPin || !confirmPin) {
            toast.error("All fields are required!", {className: "custom-toast"});
            return;
        }

        if (newPin !== confirmPin) {
            toast.error("New PIN and Confirm PIN must match!", {className: "custom-toast"});
            return;
        }
        if (newPin.length !== 4 || confirmPin.length !== 4) {
            toast.error("PIN must be exactly 4 digits!", {className: "custom-toast"});
            return;
        }

        const credentials = {
            pin: newPin,
            pin_confirmation: confirmPin,
        }

        setLoading(true);

        try {
            const { data } = await setTransactionPin(credentials);
            // console.log(data);
            
            refreshUserDetails(dispatch);
            
            setModalMessage("Your PIN has been successfully Created.");
            toast.success("PIN Setting successful!", {
                toastId: "pin-change-success-toast",
                className: "custom-toast",
            });

            const modal = new Modal(document.getElementById('pinChangeModal'));
            modal.show();

            setOldPin("");
            setNewPin("");
            setConfirmPin("");
            setOtp("");
        } catch (error) {
            toast.error(error.response.data.message.message || "PIN creation failed!", {
                toastId: "pin-change-fail-toast",
                className: "custom-toast",
            });
            setModalMessage("Failed to set your PIN. Please try again.");
            // console.error('Error Setting PIN:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newPin || !confirmPin) {
            toast.error("All fields are required!", {className: "custom-toast"});
            return;
        }

        if (newPin !== confirmPin) {
            toast.error("New PIN and Confirm PIN must match!", {className: "custom-toast"});
            return;
        }
        if (newPin.length !== 4 || confirmPin.length !== 4) {
            toast.error("PIN must be exactly 4 digits!", {className: "custom-toast"});
            return;
        }
        if (isPinReset && otp.length !== 6) {
            toast.error("OTP must be exactly 6 digits!", {className: "custom-toast"});
            return;
        }
        if (!isPinReset && newPin === oldPin) {
            toast.error("New PIN cannot be the same as the old PIN!", {className: "custom-toast"});
            return;
        }

        const credentials = {
            new_pin: newPin,
            new_pin_confirmation: confirmPin,
            ...(isPinReset ? { otp } : {current_pin: oldPin}),
        }

        setLoading(true);

        try {
            const { data } = isPinReset ? await resetTransactionPin(credentials) : await changeTransactionPin(credentials);
            // console.log(data);
            
            refreshUserDetails(dispatch);
            
            setModalMessage("Your transfer PIN has been successfully changed.");
            toast.success("Transfer PIN updated successfully!", {
                toastId: "pin-change-success-toast",
                className: "custom-toast",
            });

            const modal = new Modal(document.getElementById('pinChangeModal'));
            modal.show();

            setOldPin("");
            setNewPin("");
            setConfirmPin("");
            setOtp("");
        } catch (error) {
            toast.error(error.response.data.message.message || "PIN change failed!", {
                toastId: "pin-change-fail-toast",
                className: "custom-toast",
            });
            setModalMessage("Failed to change your transfer PIN. Please try again.");
            // console.error('Error changing PIN:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePinResetRequest = async () => {
        setLoading(true);
        try {
            const { data } = await resetTransactionPinRequest();
            // console.log(data);
            toast.success(data.message || "PIN reset request sent successfully!", {
                toastId: "pin-reset-success-toast",
                className: "custom-toast",
            })
            setIsPinReset(true);  
            setOldPin("");
            setNewPin("");
            setConfirmPin("");
            setOtp("");          
        } catch (error) {
            // console.error('Error requesting PIN reset:', error);
            toast.error(error.response.data.message.message || "PIN reset request failed!", {
                toastId: "pin-reset-fail-toast",
                className: "custom-toast",
            })            
        } finally {
            setLoading(false);
        }
    };

    const handleGoBack = () => {
        if (isSettingPage) {
            navigate(-1);
        } else {
            navigate(`/user/cards/card_option`);
        }
    };

    return (
        <section className="create__card__page card__fund__page">
            {!isSettingPage && (
                <div className="d-flex align-items-center mt-3">
                    <button onClick={handleGoBack} className="btn btn-sm" style={{ color: '#777' }}>
                        <FaAngleLeft size={15} />
                        <span className="ms-1 small mt-1">Back to Card Options</span>
                    </button>
                </div>
            )}

            <section className="create-card_section funding__card__section">
                <div className="container">
                    <form onSubmit={hasPinSet ? handleSubmit : handlePinSetting} className="funding__form pin__action__form">
                        <div className="form__card-section mb-5">
                            {hasPinSet && (
                                <div className="mb-4">
                                    <label className="form-label mb-0">{ isPinReset ? "Enter OTP sent to your email" : "Enter your current PIN" }</label>
                                    <div className="input-group">
                                        <input 
                                            type={passwordType} 
                                            className="form-control" 
                                            value={ isPinReset ? otp : oldPin } 
                                            onChange={handleInputChange(isPinReset ? setOtp : setOldPin)} 
                                        />
                                        <span className='input-group-text' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                            {passwordType === 'password' ? <PiEyeSlashThin color="#0986E6" size={20} /> : <PiEyeThin color="#0986E6" size={20} />}
                                        </span>
                                    </div>
                                    <span onClick={handlePinResetRequest} className='reset__pin forget__password small' role='button' title='click to reset'>Have you forgotten your PIN?</span>
                                </div>
                            )}

                            <div className="mb-4">
                                <label className="form-label mb-0">Enter New PIN</label>
                                <div className="input-group">
                                    <input 
                                        type={passwordType} 
                                        className="form-control" 
                                        value={newPin} 
                                        onChange={handleInputChange(setNewPin)} 
                                    />
                                    <span className='input-group-text' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                        {passwordType === 'password' ? <PiEyeSlashThin color="#0986E6" size={20} /> : <PiEyeThin color="#0986E6" size={20} />}
                                    </span>
                                </div>
                            </div>

                            <div className="mb-4">
                                <label className="form-label mb-0">Confirm New PIN</label>
                                <div className="input-group">
                                    <input 
                                        type={passwordType} 
                                        className="form-control" 
                                        value={confirmPin} 
                                        onChange={handleInputChange(setConfirmPin)} 
                                    />
                                    <span className='input-group-text' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                        {passwordType === 'password' ? <PiEyeSlashThin color="#0986E6" size={20} /> : <PiEyeThin color="#0986E6" size={20} />}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Change PIN Button */}
                        <div className="d-flex align-items-center justify-content-center mt-4">
                            <button 
                                type="submit" 
                                className="btn primary__btn w-100" 
                                disabled={!isEdited || !newPin || !confirmPin || loading}
                            >
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    hasPinSet ? "Change PIN" : "Set PIN"
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </section>

            {/* Bootstrap Modal */}
            <section className="modal fade show" id="pinChangeModal" tabIndex="-1" aria-labelledby="pinChangeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="d-flex justify-content-end p-3">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body my-2 mx-4 text-center">
                            <h4>{modalMessage.includes("successfully") ? `PIN ${hasPinSet ? "Changed" : "Set"} Successfully` : `Error ${hasPinSet ? "Changing" : "Setting"} PIN`}</h4>
                            <p>{modalMessage}</p>
                            <button className="btn primary__btn__outline mt-5 w-50 mx-auto" data-bs-dismiss="modal" aria-label="Close">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
};

export default ChangePin;
